import React from 'react';
import { useSearchkit } from '@searchkit/client';
import Button from '../../../../Button';
var CustomValueFilter = function CustomValueFilter(_ref) {
  var filter = _ref.filter;
  var api = useSearchkit();
  return /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      api.removeFilter(filter);
      api.search();
    }
  }, filter.label, ": ", filter.value);
};
export default CustomValueFilter;